import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { Link } from 'react-router'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import map from 'lodash/map'
import { Condition, ConditionLegend } from 'client/components/Condition'
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import {styles} from 'common/lib/styles';
import { withStyles } from '@material-ui/core/styles';
import PartItem from 'client/components/PartItem';
import actions from 'client/actions'
import { Avatar, Button, Paper } from '@material-ui/core';
import { getRemainingLifetime } from 'client/lib/keyNumbers';
import noImage from 'assets/images/no-image.png'

class PartsList extends Component {

  static propTypes = {
    parts: PropTypes.array.isRequired,
    params: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired,
  }

  constructor (props) {
    super(props)
    this.partLinkHandler = this.partLinkHandler.bind(this)
  }

  headers = [
    'Tilstand', 'BIPS', 'Bygningsdel',
    'Antal', 'Rest Levetid',
    'Eftersyn', 'Vedligehold', 'Noter',
  ]

  componentDidMount() {
      const { dispatch, setBreadcrumb } = this.props
      dispatch(setBreadcrumb('Bygningsdele'));
  }

  partLinkHandler (customer_id, id) {
    const { dispatch, push } = this.props
    return ev => {
      dispatch(push(`/c/${customer_id}/parts/${id}`))
    }
  }

  render () {
    const { classes, parts, params, projects } = this.props

    return (
            <Grid container>
                <Paper className={`${classes.paperWithoutHeight} ${classes.paperPrint}`}>
                    <Typography className={classes.header} variant="h5">Bygningsdelskort</Typography>
                    <Typography paragraph>Vælg det enkelte bygningsdelskort og se stamdata, specifikation, billeder, samt anvisninger for vedligehold og eftersyn</Typography>
                    <hr/>
                    <div className={classes.infoTableContainer}>
                        <div className={`${classes.infoTableHeader} ${classes.justifyContentUnset}`}>
                            <Typography className={`${classes.greyText} ${classes.width150}`}>
                            </Typography>
                            <Typography className={`${classes.greyText} ${classes.oneSixth}`}>
                                Bygningsdel
                            </Typography>
                            <Typography className={`${classes.greyText} ${classes.oneSixth}`}>
                                Tilstand
                            </Typography>
                            <Typography className={`${classes.greyText} ${classes.oneSixth}`}>
                                Antal
                            </Typography>
                            <Typography className={`${classes.greyText} ${classes.oneSixth}`}>
                                Restlevetid
                            </Typography>
                            <Typography className={`${classes.greyText} ${classes.oneSixth} ${classes.hidePrint}`}>
                            </Typography>
                        </div>
                    </div>
                { parts.map((part, idx) => <div key={idx} className={`${classes.infoTable} ${classes.justifyContentUnset}`}>
                    <Typography className={`${classes.blueText} ${classes.width150}`}>
                            <div className={classes.partAvatarContainer}>
                                <Avatar className={classes.partAvatar} src={part.images.length > 0 ? `https://ik.imagekit.io/aw3ddey5g/${part.images[0].s3_image_id}?tr=w-223,h-167` : noImage} />
                            </div>
                    </Typography>
                    <Typography className={`${classes.blueText} ${classes.oneSixth}`}>{part.title}</Typography>
                    <Typography className={`${classes.blueText} ${classes.oneSixth}`}>
                        <Condition condition={ part.condition } hasText={ true } />
                    </Typography>
                    <Typography className={`${classes.blueText} ${classes.oneSixth}`}>
                        {part.amount}
                    </Typography>
                    <Typography className={`${classes.blueText} ${classes.oneSixth}`}>
                        { getRemainingLifetime(part.remaining_lifetime_range) }
                    </Typography>
                    <Typography className={`${classes.blueText} ${classes.oneSixth} ${classes.hidePrint}`}>
                        <Button className={classes.button} onClick={ this.partLinkHandler(params.customer_id, part.id)}>Se detaljer</Button>
                    </Typography>
                </div>)}
                </Paper>
            </Grid>
    //   <div>
    //     <section id="masthead" className="wrapper">
    //       <div className="container">
    //         <div className="row">
    //           <div className="col-md-7">
    //             <h1><i className="fa fa-bars"></i> { parts.length } Bygningsdel{ parts.length > 1 ? 'e' : '' }</h1>
    //             <p className="text-muted">Drifts- og vedligeholdelsesplan: <span className="plan">{ plan.name }</span></p>
    //           </div>
    //           <PrintButton component="parts" customer_id={ customer_id } />
    //         </div>
    //       </div>
    //     </section>

    //     <section>
    //       <div className="container">
    //         <hr />
    //         <div className="lead text-center part-switch-links">
    //           {
    //             queryView === 'item'
    //               ? <span><i className="fa fa-image"></i> Vis som billedeoversigt</span>
    //               : (
    //                 <a href={ `${url}?view=item` } onClick={ this.switchViewHandler(`${url}?view=item`) }>
    //                   <i className="fa fa-image"></i> Vis som billedeoversigt
    //                 </a>
    //               )
    //           }
    //           <span className="text-muted"> | </span>
    //           {
    //             queryView === 'list'
    //               ? <span><i className="fa fa-list"></i> Vis som liste</span>
    //               : (
    //                 <a href={ `${url}?view=list` } onClick={ this.switchViewHandler(`${url}?view=list`) }>
    //                   <i className="fa fa-list"></i> Vis som liste
    //                 </a>
    //               )
    //           }
    //         </div>
    //         <hr />
    //         { view }
    //       </div>
    //     </section>
    //   </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    plan: state.data.customer.plan,
    parts: state.data.customer.parts,
    projects: state.data.customer.projects,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    setBreadcrumb: actions.setBreadcrumb,
    push,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(PartsList))
